// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "img[data-v-e029cbe0]{-webkit-user-drag:none;-khtml-user-drag:none;-moz-user-drag:none;-o-user-drag:none;user-drag:none}.buttons[data-v-e029cbe0]{bottom:10px}.buttons[data-v-e029cbe0],.buttons2[data-v-e029cbe0]{right:20px;position:absolute;z-index:99}.buttons2[data-v-e029cbe0]{top:10px}@media (max-width:1000px){.btn-sm[data-v-e029cbe0]{padding:0}.buttons[data-v-e029cbe0]{bottom:70px}}", ""]);
// Exports
module.exports = exports;
